import {z} from "zod";

export enum VCycleElementType {
    PROCESS_AREA = 'PROCESS_AREA',
    REPRESENTATION = 'REPRESENTATION',
}

export const VCycleElementTypeSchema = z.enum(VCycleElementType);
